// TODO: This file could/should be part of a larger split up of SoqlHelpers.
// It was mainly started to remove a circular dependency caused by selectAlias

/**
 * Returns a safe Soql select alias string,
 * with optional id.
 */
export function selectAlias(idx?: number) {
  return `__select_alias${idx || ''}__`;
}
